import * as qs from 'qs';

import type { ReportV3Format } from '../types';

/**
 * Build the V2 public report URL with format and report-options query params.
 *
 * `reportOptionsParams` comes from `useReportOptionsParams()` — a query string
 * that reflects the standard-flow defaults or the custom-flow selections. We
 * parse it so we can merge `format` through `qs.stringify` rather than by
 * string concatenation, preserving nested keys (e.g. `excludeFields`).
 */
export function buildPublicReportURL(params: {
  projectLocator: string;
  format: ReportV3Format | undefined;
  reportOptionsParams: string;
}): string {
  const merged = {
    ...qs.parse(params.reportOptionsParams),
    ...(params.format ? { format: params.format } : {}),
  };
  const queryString = qs.stringify(merged);
  const base = `/api/v2/revisions/${params.projectLocator}/attribution/public`;
  return queryString ? `${base}?${queryString}` : base;
}
